import { h} from 'preact';
import { Text } from 'preact-i18n';
import { GetSafeImageUrl } from '../../utils/ApiUtil';
import Markup from 'preact-markup';

  // for a given price string, extract the numeric value, localize its format, replace it in the orig string, return
  let localizePrice = (p, locale) => {
    if(!p || p == '')
      return '';
    if(!locale || locale == '')
      return p;

    // pull out the price
    let rxgetnum = /([0-9\.\,]+)/;
    let arr = rxgetnum.exec(p);
    let myprice = p;
    if(arr && arr.length > 0) {
      let oldprice = arr[1];
      let fprice = parseFloat(oldprice);
      let lprice = fprice.toLocaleString(locale, {maximumFractionDigits: 2, minimumFractionDigits: 2});
      myprice = myprice.replace(oldprice, lprice);
    }
    return myprice;
  }

export const OneProduct = props =>  {
    let productBlock = props.product;
    let item = productBlock;
    let mylocale = props.locale;
    let price = "";
    let showprice = true;
    if(item.hideprice == true) {
      price = <Text id="newSearch.clickSeePrice">click to see price</Text>;
    } else {
      if(item.strikethrough == true) {
        price = <span><span className="pricestrikeout">{item.originalprice}</span>&nbsp;{localizePrice(item.price, mylocale)}</span>;
      } else if (item.price) {
        price = <span>{localizePrice(item.price, mylocale)}</span>;
      }
      else {
        showprice = false;
      }
    }

    let renderDeliveryInfo = (deliveryInfo) => {
        if(!deliveryInfo) {
          return ("");
        }
        let splits = deliveryInfo.split("|");
        let isFirst = true;
        let toRet = splits.map(s => {
          if(!s) {
            return s;
          }
          if(isFirst) {
            isFirst = false;
            return (
              <Text id={'newSearch.' + s}>{s}</Text>
            )
          }
          return (
              <span>&nbsp;|&nbsp;<Text id={'newSearch.' + s}>{s}</Text></span>
            )
        })
        return toRet;
      }    

    //let snippet = (webBlock.snippet && webBlock.snippet.length > 200) ? webBlock.snippet.substr(0, 197) + "..." : webBlock.snippet;
    return (
      <div>
        <a className="ae-border-box ae-dark shopping-product" href={productBlock.deeplinkuri} target="_blank">
            <div className="product-info">
                <div className="ae-subtitle-large ae-blue-text product-title">{productBlock.title}</div>
                <div className="ae-para product-price">
                    <Text id="newSearch.buyFrom">Buy from</Text>: {item.source} {item.classification ? `(${item.classification})` : ''}<br/>
                    {showprice ? <span><Text id="newSearch.price">Price</Text>: {price}<br/></span> : ''}
                    {
                        item.deliveryinfo && item.deliveryinfo !== ''
                        ?
                        (<span><Text id="newSearch.shippingInfo">Shipping Info</Text>: {renderDeliveryInfo(item.deliveryinfo)}<br/></span>)
                        :
                        (item.deliveryprice ? (<span><Text id="newSearch.shipping">Shipping</Text>: {localizePrice(item.deliveryprice, mylocale)}<br/></span>) : '')
                    }
                </div>
            </div>
            <div className="product-image">
                <img src={GetSafeImageUrl(productBlock.imageuri)} />
            </div>
        </a>
      </div>
    )

}

export const ThinkSuggestShoppingResult = props =>  {
  const item = props.item;
  return (
    <div className="think-suggest-shopping-result-block">
      <div className="ae-title result-title think-suggest-title-shopping">
        {item.imageuri ? (<img className="image" src={GetSafeImageUrl(item.imageuri)} width='20' height='20'/>) : ""}
        <a className="link" href={item.deeplinkuri}><Markup markup={item.classification} type="html" trim={false}/></a>
      </div>
      <div className="ae-caption result-url"><Markup markup={item.snippet} type="html" trim={false}/> </div>
      <div className="ae-para result-snippet">
        <Markup markup={item.title} type="html" trim={false}/>
      </div>
    </div>
  )
}